function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import DesktopContentComponent from "./desktop-content/desktop-content-component";
import MobileContentComponent from "./mobile-content/mobile-content-component";
import { StyledOnePagerWithImageContentComponent } from "./one-pager-with-image-content-component.scss";
import SocialProofComponent from "components/segments/social-proof/social-proof-component";
import ShortFooterComponent from "components/segments/short-footer/short-footer-component";
import VideosGalleryComponent from "components/segments/videos-gallery/videos-gallery-component";
class OnePagerWithImageContentComponent extends PureComponent {
    render() {
        const { videosGallery, SocialProof, ShortFooter } = this.props;
        const { showSocialProof, content: socialProofContent } = SocialProof;
        const { showShortFooter, content: shortFooterContent } = ShortFooter;
        return /*#__PURE__*/ _jsxs(StyledOnePagerWithImageContentComponent, {
            className: "one-pager-with-image-content-component",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "desktop-content-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx(DesktopContentComponent, _object_spread({}, this.props)),
                        showSocialProof && /*#__PURE__*/ _jsx(SocialProofComponent, _object_spread({}, socialProofContent)),
                        showShortFooter && /*#__PURE__*/ _jsx(ShortFooterComponent, _object_spread({}, shortFooterContent)),
                        videosGallery && /*#__PURE__*/ _jsx(VideosGalleryComponent, _object_spread({}, videosGallery))
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mobile-content-wrapper",
                    children: /*#__PURE__*/ _jsx(MobileContentComponent, _object_spread({}, this.props))
                })
            ]
        });
    }
}
export { OnePagerWithImageContentComponent as default };
OnePagerWithImageContentComponent.defaultProps = {
    textPart: {},
    imageWithBackgroundPart: {},
    collaborationWith: {},
    SocialProof: {},
    ShortFooter: {}
};
